import React, { useState } from 'react';
import './navbar.css'; // Ensure this file exists for styles

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuItemClick = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 60; // Adjust this value based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    setIsOpen(false); // Close the menu when a link is clicked
  };

  return (
    <div className="n-wrapper">
      <div className="n-left">
        <div className="n-name" style={{ cursor: 'pointer' }}>Kabita</div>
      </div>

      <div className="n-right">
        <div className="n-list">
          <ul style={{ listStyleType: 'none' }}>
            <li><a href="#intro" onClick={() => handleMenuItemClick('intro')}>Home</a></li>
            <li><a href="#aboutme" onClick={() => handleMenuItemClick('aboutme')}>About</a></li>
            <li><a href="#services" onClick={() => handleMenuItemClick('services')}>Services</a></li>
            <li><a href="#portfolio" onClick={() => handleMenuItemClick('portfolio')}>Portfolio</a></li>
            <li><a href="#Testimonials" onClick={() => handleMenuItemClick('Testimonials')}>Testimonials</a></li>
          </ul>
        </div>

        <button className="button n-button">
          <a href="#Contact" onClick={() => handleMenuItemClick('Contact')} style={{ textDecoration: 'none', color: 'inherit' }}>Contact</a>
        </button>
      </div>

      {/* Hamburger Menu */}
      <div className={`menu-icon ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <div className=" bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <ul>
          <li><a href="#intro" onClick={() => handleMenuItemClick('intro')}>Home</a></li>
          <li><a href="#aboutme" onClick={() => handleMenuItemClick('aboutme')}>About</a></li>
          <li><a href="#services" onClick={() => handleMenuItemClick('services')}>Services</a></li>
          <li><a href="#portfolio" onClick={() => handleMenuItemClick('portfolio')}>Portfolio</a></li>
          <li><a href="#Testimonials" onClick={() => handleMenuItemClick('Testimonials')}>Testimonials</a></li>
          <li><a href="#Contact" onClick={() => handleMenuItemClick('Contact')}>Contact</a></li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;